/*
 *  Collection Template
 *    Contains all the scripts used for the collection template.
 *
 *  Version:
 *    1.0.0 - 2022/06/30
 */

import $ from 'jquery';

import { AjaxCollectionTemplate, TagFilter, OPERATION_OR } from '@process-creative/slate-ajax-collection';
import { t } from '@process-creative/slate-theme-tools';
import { CollectionPageNumbers } from './pagination/page-numbers';
import { ProductThumbnailPrint } from '../../objects/product/product-thumbnail-print';
import { CustomSelectSorter } from './sort/CustomSelectSort';
import { CustomSmartTagButtonFacet } from './fasets/CustomButtonFacet';
import { initialiseProductThumbnails } from '../../objects/product/product-thumbnail';

// Selectors
const SELECTOR_COLLECTION_TEMPLATE = '[data-collection-template]';
const SELECTOR_FACETED_NAV_FILTER = '[data-faceted-nav-type-tag]';
const SELECTOR_SORT = '[data-collection-sort]';
const SELECTOR_NO_RESULTS = '[data-collection-no-results]';
const SELECTOR_PAGINATION_CONTAINER = '[data-pagination-container]';
const SELECTOR_IS_SWATCHES = '[data-collection-enable-swatches]';

//Classes
const CLASS_VISIBLE = 'is-visible';


export class CollectionTemplate extends AjaxCollectionTemplate {
  constructor(container) {
    super(container);
    this.container = container;
    this.setupCollection();
    this.init();
  }

  setupCollection() {
    console.log('here')
    // this.noResults = this.container.find(SELECTOR_NO_RESULTS);
    this.setupFiltersAndFacets();
    this.setElements();
  }

  setupFiltersAndFacets() {

    this.setupSortElements();

    // Setup Filters
    [
      this.tagFilter = new TagFilter(this, 'filter', OPERATION_OR)
    ].forEach(filter => this.filters.addFilter(filter));

    // Setup Facets
    [
      new CustomSmartTagButtonFacet({
        template: this, filter: this.tagFilter,
        title: t('collections.collection.filter_type'),
        container: SELECTOR_FACETED_NAV_FILTER,
        prefixes: ['type'],
        hasAll: true
      })
    ].forEach(facet => this.filters.addFacet(facet));
  }

  setElements() {
    // Elements
    this.noResults = this.container.find(SELECTOR_NO_RESULTS);

    // Pagination
    this.pagination.setPaginator(
      new CollectionPageNumbers(this, this.container.find(SELECTOR_PAGINATION_CONTAINER))
    );
  }

  setupSortElements() {

    const sortMethods = Object.values(this.sort.getSortMethods()).filter(arrayItem => typeof arrayItem == 'object');
    const sortElems = this.container[0].querySelectorAll(SELECTOR_SORT);

    sortElems.forEach(sortElem => {
      this.sort.addSorter(new CustomSelectSorter({
        template: this,
        sortElem,
        sortMethods
      }));
    });
    this.draw.setDisplayMode('FirstAvailableVariant');
  }

  generatePrint(v) {

    const p = v.product;
    const p2 = { ...p }; // Duplicate
    const isSwatches = $(SELECTOR_IS_SWATCHES).data('collection-enable-swatches');

    p2.variants = p2.variants.map(variant => {
      const v2 = { ...variant }; // Duplicate
      delete v2.product; // Remove circular reference
      return v2;
    });

    return ProductThumbnailPrint({ p, p2, v, clazz: 'o-products-list__product', is_swatches: isSwatches});
  }

  onVariantsDrawn(variants) {

    if (variants && variants.length) {
      this.noResults.removeClass(CLASS_VISIBLE);
    } else {
      this.noResults.addClass(CLASS_VISIBLE);
    }

    initialiseProductThumbnails();
  }
}

$(() => {

  const container = $(SELECTOR_COLLECTION_TEMPLATE);

  if (!container || !container.length) return;
  if (container.attr('data-initialized')) return;

  // Create the template, we use window.collection for TESTING only!!
  window.collection = new CollectionTemplate(container);
});
